import { render, staticRenderFns } from "./GfEmployeeLoanList.vue?vue&type=template&id=9067d972"
import script from "./GfEmployeeLoanList.vue?vue&type=script&lang=js"
export * from "./GfEmployeeLoanList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports